const localReferences = {
    event: {
        eventTypes: {
            eventPartner: 1, //Партнёр
            eventSite: 2, //Заявка с сайта
            eventCall: 3, //Звонок
            eventEmail: 4, //E-mail
            eventChange: 5, //Изменен
            eventTask: 6, //Задача
            eventIncomeCall: 7, //Входящий звонок
            eventOutcomeCall: 8, //Исходящий звонок
            eventIncomeEmail: 9, //Входящее письмо
            eventOutcomeEmail: 10, //Исходящее письмо
            eventComment: 11, //Комментарий
            eventSelf: 12, //Создана вручную
            eventOffice: 13, //Визит в офис
            eventSms: 14, //СМС
            eventRevvy: 15 //WhatsApp revvy
        },
        initiatorTypes: {
            employer: 'employer',
            other: 'other'
        }
    },
    taskStatuses: {
        assigned: 1,
        onCheck: 2,
        finished: 3
    },
    taskPriorities: {
        low: 'low',
        middle: 'middle',
        high: 'high'
    },
    taskPrioritiesList: [
        { id: 'low', name: 'Низкий' },
        { id: 'middle', name: 'Средний' },
        { id: 'high', name: 'Высокий' }
    ],
    leadStatuses: {
        statusNew: 1,
        statusTarget: 2,
        statusNotTarget: 3
    },
    referenceLink: {
        link_call: 1, //звонок
        link_from_site: 2, //заявка с сайта
        link_self: 3, //вручную
        link_email: 4, //e-mail
        link_from_office: 5, //визит в офис
        link_partner: 6, //Со страницы партнеров
        link_accepted: 7, //Принят
        link_missed_call: 8, //Пропущенный звонок
        link_self_auto: 9, //Создана вручную
        link_whatsapp: 10 //whatsapp
    },
    dealStatuses: {
        contactEstablished: 1,
        measuring: 2,
        measuredWatch: 3,
        contract: 4,
        delivery: 5,
        installationPlanned: 6,
        installationDone: 7,
        successfullyImplemented: 8,
        complainOpen: 9,
        complainClosed: 10,
        contractFixation: 11,
        deferredDemand: 12,
        closedNotImplemented: 13,
        refuseBeforeMetering: 14,
        techRefusal: 15
    },
    dealExpenseNames: {
        bonus_1_percent: 'bonus_1_percent',
        bonus_deal: 'bonus_deal',
        fine_deal: 'fine_deal',
        bonus_measurer: 'bonus_measurer',
        finish: 'finish',
        jalousie: 'jalousie',
        complaint_materials: 'complaint_materials',
        complaint_work: 'complaint_work'
    },
    employerPositions: {
        administrator: 1,
        measurer: 2,
        manager: 3,
        headOffice: 4,
        chiefTechnologist: 5,
        headInstallation: 6,
        installer: 7,
        headOfService: 8,
        serviceSpecialist: 9,
        accountant: 10,
        ceo: 11,
        financeDirector: 12,
        coordinator: 13,
        fired: 14
    },
    reasonsRefuse: {
        status_target: 1,
        status_not_target: 2
    },
    complaintGuilty: {
        factory: 1,
        installer: 2,
        measurer: 3,
        customer: 4,
        warrantyCase: 5
    },
    entities: {
        lead: 'lead',
        deal: 'deal'
    },
    measurementTimes: [
        '09-10',
        '12-13',
        '15-16',
        '18-19'
    ],
    expenseType: {
        prepayment: 'prepayment'
    },
    expenseTypeName: {
        prepayment: 'Аванс'
    },
    expensePage: {
        prepayments: 'expenses-prepayments'
    },
    getNextTime: (time) => {
        const index = localReferences.measurementTimes.indexOf(time);
        if (index !== -1 && (index + 1) !== localReferences.measurementTimes.length) {
            return localReferences.measurementTimes[index + 1];
        }
        return null;
    },
    getPrevTime: (time) => {
        const index = localReferences.measurementTimes.indexOf(time);
        if (index !== -1 && (index - 1) !== -1) {
            return localReferences.measurementTimes[index - 1];
        }
        return null;
    },
    logSystemEntityTypes: {
        free: 'Не указан',
        lead: 'Лид',
        deal: 'Сделка',
        contact: 'Контакт',
        company: 'Компания',
        employer: 'Сотрудник',
        income: 'Приход',
        expense: 'Расход'
    },
    logSystemEventTypes: {
        edit: 'Изменение',
        create: 'Создание'
    },
    garbageRemovals: {
        notSet: 1,
        actionPlastic: 2,
        paid: 3,
        none: 4
    },
    mapCenterCoordinates: [55.76, 37.64],
    complaintPerformerTypes: {
        service: 'service',
        factory: 'factory',
        installer: 'installer'
    },
    offices: {
        varshavskiy: 1,
        borisovo: 2,
        ahmatova: 3,
        all: 4
    },
    payTypes: {
        cash: 1,
        cashless: 2,
        card: 3
    },
    payTypesFull: {
        cash: 1,
        pos: 2,
        site: 3,
        requisites: 4,
        card: 6
    },
    incomeRecievedByType: {
        employer: 'employer',
        cash: 'cash',
        factory: 'factory'
    },
    incomeRecievedFromType: {
        contact: 'contact',
        employer: 'employer'
    },
    incomeDetails: {
        prepayment: 1,
        delivery: 2,
        install: 3
    },
    operationStatuses: {
        new: 1,
        onCheck: 2,
        toFix: 3,
        executed: 4
    },
    operationTypes: {
        salaryPayout: 1,
        suppliersCalculation: 2,
        cashCorrection: 3,
        deal: 4,
        other: 5
    },
    expenseTypes: {
        salary: 1,
        additional_work: 2
    },
    expenseSource: {
        employer: 'employer',
        cash: 'cash'
    },
    expenseRecipient: {
        employer: 'employer',
        cash: 'cash',
        contractor: 'contractor',
        factory: 'factory',
        contact: 'contact'
    },
    expenseRecipientName: {
        employer: 'Сотрудник',
        cash: 'Касса',
        contractor: 'Контрагент',
        factory: 'Производство',
        contact: 'Клиент'
    },
    monthsList: Array.from({ length: 12 }, (v, k) => k + 1 < 10 ? `0${k + 1}` : `${k + 1}`),
    yearsList: Array.from({ length: new Date().getFullYear() - 2016 + 10 }, (v, k) => `${k + 2016}`),
    numericOptionsGeneral: {
        digitGroupSeparator: ' ',
        decimalCharacter: ',',
        decimalPlaces: 0,
        decimalCharacterAlternative: '.',
        roundingMethod: 'U',
        isCancellable: true,
        emptyInputBehavior: '0',
        modifyValueOnWheel: false,
        minimumValue: '0',
        maximumValue: '9999999'
    },
    timesheet: {
        constraints: {
            minWorkingMeasurersPerDay: 11,
            maxDayOffPerMonth: 9,
            daysBeforeManagerCanTakeDayOff: 3,
            daysBeforeOthersCanTakeDayOff: 5
        },
        statuses: {
            dayOff: 1,
            sick: 2,
            vacation: 3,
            working: 4
        }
    }
};

localReferences.payTypesCash = [
    localReferences.payTypes.cash,
    localReferences.payTypes.card
];

localReferences.payTypesCashless = [
    localReferences.payTypes.cashless
];

localReferences.payTypesFullCash = [
    localReferences.payTypesFull.cash,
    localReferences.payTypesFull.card
];

localReferences.payTypesFullCashless = [
    localReferences.payTypesFull.pos,
    localReferences.payTypesFull.site,
    localReferences.payTypesFull.requisites
];

export default localReferences;
